import { render, staticRenderFns } from "./IndividualAssessment.vue?vue&type=template&id=61dac8d8"
import script from "./IndividualAssessment.vue?vue&type=script&lang=js"
export * from "./IndividualAssessment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports